{
	"name": "lambda-layer-packager",
	"description": "A professional CLI tool designed to package Node.js modules into a zip file for AWS Lambda Layers, facilitating efficient deployment and management of serverless applications.",
	"version": "2.4.1",
	"license": "MIT",
	"author": {
		"email": "vijayanand431@gmail.com",
		"name": "Vijay Gangatharan"
	},
	"keywords": [
		"aws-lambda-layers",
		"lambda-deployment",
		"aws-serverless",
		"node-packager",
		"lambda-dependencies",
		"aws-toolkit",
		"serverless-architecture",
		"aws-development",
		"lambda-optimization",
		"nodejs-deployment",
		"deployment-automation",
		"aws-infrastructure",
		"devops-tools",
		"cloud-deployment",
		"npm-packaging",
		"serverless-tools",
		"lambda-management",
		"aws-cli",
		"deployment-tool",
		"cloud-native"
	],
	"repository": {
		"url": "git+https://github.com/Vijay431/lambda-layer-packager.git"
	},
	"publishConfig": {
		"access": "public",
		"registry": "https://registry.npmjs.org"
	},
	"engineStrict": true,
	"engines": {
		"node": ">=18"
	},
	"bin": {
		"packager": "bin/packager.js"
	},
	"scripts": {
		"format": "npx lint-staged",
		"lint": "npx eslint@8.57.0 --fix",
		"pretty": "npx prettier --write .",
		"clean": "shx rm -rf dist",
		"build": "npm run clean && parcel build",
		"prepublishOnly": "npm run build"
	},
	"dependencies": {
		"archiver": "^5.3.1",
		"commander": "^10.0.1",
		"figlet": "^1.6.0",
		"tslib": "^2.6.2"
	},
	"devDependencies": {
		"@parcel/config-default": "^2.12.0",
		"@parcel/core": "^2.12.0",
		"@parcel/packager-ts": "^2.12.0",
		"@parcel/transformer-typescript-types": "^2.12.0",
		"@types/archiver": "^5.3.2",
		"@types/chai": "^4.3.11",
		"@types/figlet": "^1.5.6",
		"@types/node": "^18.16.19",
		"@types/spinnies": "^0.5.3",
		"@typescript-eslint/eslint-plugin": "^5.62.0",
		"@typescript-eslint/parser": "^5.62.0",
		"eslint": "^8.45.0",
		"eslint-config-prettier": "^8.10.0",
		"eslint-plugin-prettier": "^5.1.2",
		"eslint-plugin-security": "^2.1.0",
		"husky": "^8.0.3",
		"lint-staged": "^15.2.0",
		"parcel": "^2.12.0",
		"prettier": "^3.1.1",
		"shx": "^0.3.4",
		"spinnies": "^0.5.1",
		"ts-node": "^10.9.2",
		"typedoc": "^0.25.12",
		"typescript": "^5.1.6"
	},
	"source": "src/commands/index.ts",
	"main": "./dist/main.js",
	"module": "./dist/module.js",
	"exports": {
		".": {
			"import": "./dist/main.js",
			"require": "./dist/module.js"
		},
		"./package.json": "./package.json"
	},
	"files": [
		"dist",
		"bin",
		"LICENSE",
		"README.md"
	],
	"targets": {
		"main": {
			"context": "node",
			"includeNodeModules": true,
			"sourceMap": true,
			"outputFormat": "commonjs",
			"isLibrary": true
		},
		"module": {
			"context": "node",
			"includeNodeModules": true,
			"sourceMap": true,
			"outputFormat": "esmodule",
			"isLibrary": true
		}
	}
}
